import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { WorkspaceSchema } from "../../Schemas/Workspace";

interface Filter extends IFilterSchema {
  column: WorkspaceListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: WorkspaceListColumnSortable;
}

export enum WorkspaceListColumnFilterable {
  ID = "id",
  NAME = "name",
  PHONE = "phone",
}
export enum WorkspaceListColumnSortable {
  ID = "id",
  NAME = "name",
  PHONE = "phone",
  CREATED_AT = "created_at"
}

export interface WorkspaceListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface WorkspaceListResponseBody extends IResponseBody {
  data: {
    workspaces: {
      data: WorkspaceSchema[];
      total: number;
    };
  };
}

export class WorkspaceListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/workspaces`;
  }

  async send(
    queryStrings?: WorkspaceListQueryString
  ): Promise<WorkspaceListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
